import {
  Activity,
  ClipboardList,
  FileSearch,
  ListChecks,
  Settings,
} from "lucide-react";

import { GroupsEnum } from "@/enum/groups";
import { RoleEnum } from "@/enum/role";
import PriceRemarkJustificationsRoutes from "@/pages/price-remark/justifications/justifications.routes";
import PriceRemarkLabelAuditRoutes from "@/pages/price-remark/label-audit/label-audit.routes";
import PriceRemarkPendingRoutes from "@/pages/price-remark/pending/pending.routes";
import PriceRemarkProductivityRoutes from "@/pages/price-remark/productivity/productivity.routes";
import PriceRemarkSettingsRoutes from "@/pages/price-remark/settings/settings.routes";

import { createRoute } from "../createRoute";
import { PATH_IDS } from "../path-ids";

// Acesso gateado pelo grupo ETIQUETA_REMARCADOS (← GG-SSO-REM). Qualquer papel
// do grupo pode ver/usar; as escritas são auditadas no backend.
const ALL_ROLES = [RoleEnum.ADMINISTRADOR, RoleEnum.ANALISTA, RoleEnum.USER];

export const priceRemarkRoutes = [
  createRoute({
    id: "Configurações",
    category: "Configurações",
    requiredRole: ALL_ROLES,
    groupRequired: [GroupsEnum.ETIQUETA_REMARCADOS],
    path: "/configuracoes/*",
    pathId: PATH_IDS.ETIQUETA_REMARCADOS,
    element: <PriceRemarkSettingsRoutes />,
    Icon: Settings,
  }),
  createRoute({
    id: "Pendências",
    category: "Monitoramento",
    requiredRole: ALL_ROLES,
    groupRequired: [GroupsEnum.ETIQUETA_REMARCADOS],
    path: "/pendencias/*",
    pathId: PATH_IDS.ETIQUETA_REMARCADOS,
    element: <PriceRemarkPendingRoutes />,
    Icon: ListChecks,
  }),
  createRoute({
    id: "Produtividade",
    category: "Monitoramento",
    requiredRole: ALL_ROLES,
    groupRequired: [GroupsEnum.ETIQUETA_REMARCADOS],
    path: "/produtividade/*",
    pathId: PATH_IDS.ETIQUETA_REMARCADOS,
    element: <PriceRemarkProductivityRoutes />,
    Icon: Activity,
  }),
  createRoute({
    id: "Justificativas",
    category: "Monitoramento",
    requiredRole: ALL_ROLES,
    groupRequired: [GroupsEnum.ETIQUETA_REMARCADOS],
    path: "/justificativas/*",
    pathId: PATH_IDS.ETIQUETA_REMARCADOS,
    element: <PriceRemarkJustificationsRoutes />,
    Icon: ClipboardList,
  }),
  createRoute({
    id: "Auditoria da etiqueta",
    category: "Monitoramento",
    requiredRole: ALL_ROLES,
    groupRequired: [GroupsEnum.ETIQUETA_REMARCADOS],
    path: "/auditoria/*",
    pathId: PATH_IDS.ETIQUETA_REMARCADOS,
    element: <PriceRemarkLabelAuditRoutes />,
    Icon: FileSearch,
  }),
];
